import { InjectionToken } from '@angular/core';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PermissionGuard } from '@acpgruppe/essp-ui';
import { AuthGuard } from '@acpgruppe/essp-ui';

const appPathValue = 'notfmgr';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: appPathValue
        },
        {
          path: 'start',
          pathMatch: 'full',
          redirectTo: appPathValue
        },
        {
          path: appPathValue,
          canActivate: [AuthGuard,PermissionGuard],
          loadChildren: () => import('./core/core-app.module').then(l => l.CoreAppModule)
        }

      ], { }
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }

